module.exports = __webpack_public_path__ + "img/union0.3f3957d4.svg";